// Shopper-chosen product grid density. The wrapper outlives collection-grid partial swaps, so the choice survives filtering and sorting.
// Defaults: 2 columns on phones and tablets, 3 on desktop (lg). The 3-column option only exists on desktop.
// v2: desktop now defaults to three columns, so earlier saved choices are ignored.
const STORAGE_KEY = 'collection-grid-columns-v2';
const DESKTOP_QUERY = '(min-width: 64rem)';

class SGridSwitcher extends HTMLElement {
  #ac;
  #choice = '';
  #desktop;

  connectedCallback() {
    this.#ac = new AbortController();
    const opts = { signal: this.#ac.signal };
    this.#desktop = window.matchMedia(DESKTOP_QUERY);

    try {
      const saved = localStorage.getItem(STORAGE_KEY) || '';
      if (['1', '2', '3'].includes(saved)) this.#choice = saved;
    } catch {}
    this.#apply();

    this.addEventListener('command', (event) => {
      const match = /^--cols-([123])$/.exec(event.command);
      if (!match) return;
      this.#choice = match[1];
      this.#apply();
      try {
        localStorage.setItem(STORAGE_KEY, this.#choice);
      } catch {}
    }, opts);

    this.#desktop.addEventListener('change', () => this.#apply(), opts);
  }

  disconnectedCallback() {
    this.#ac?.abort();
  }

  // The grid classes read data-columns; the highlighted icon reflects what is actually on screen for this viewport.
  #apply() {
    if (this.#choice) {
      this.dataset.columns = this.#choice;
    } else {
      delete this.dataset.columns;
    }

    const isDesktop = this.#desktop.matches;
    let effective = this.#choice || (isDesktop ? '3' : '2');
    if (effective === '3' && !isDesktop) effective = '2';

    this.querySelectorAll('[data-grid-option]').forEach((button) => {
      button.setAttribute('aria-pressed', String(button.dataset.gridOption === effective));
    });
  }
}

if (!customElements.get('s-grid-switcher')) customElements.define('s-grid-switcher', SGridSwitcher);
